import { TimeFilterInterval } from '@mews-commander/data-access';
import { CommanderThunkAction } from '@mews-commander/types';
import { createAction, DateTimeService } from '@mews/framework';
import { createSafeToUtcDateStringConverter, dateTimeToUtc } from '@mews-commander/utils';
import { getCurrentEnterpriseIanaTimeZoneIdentifier } from '@mews-commander/legacy-entities/src/selectors/session/enterprise';
import { SET_FILTERS } from '../actionTypes';
import { FilterDateValues } from '../types';

export const setFilters = ({ startUtc, endUtc }: TimeFilterInterval) => createAction(SET_FILTERS, { startUtc, endUtc });

export const filtersSubmit =
    (values: FilterDateValues): CommanderThunkAction =>
    (dispatch, getState, { container }) => {
        const {
            appLocalizationComponent: { parseDate },
        } = container();

        const safeConvertToUtcDateString = createSafeToUtcDateStringConverter(parseDate);
        const startUtc = safeConvertToUtcDateString(values.startDate) as string;
        const endUtc = safeConvertToUtcDateString(values.endDate) as string;

        const timezone = getCurrentEnterpriseIanaTimeZoneIdentifier(getState());
        const endOfDayUtc = dateTimeToUtc(DateTimeService.endOfDay(DateTimeService.fromUtcString(endUtc, timezone)));

        dispatch(
            setFilters({
                startUtc,
                endUtc: endOfDayUtc,
            })
        );
    };
